export default __webpack_public_path__ + "static/media/logo.49f6a721.svg";